import React from 'react';
import { observer } from 'mobx-react-lite';
import { Window, WindowHeader } from '../overlays';
import { Button } from '../input';
import { TogglePublicSafetyWindowState } from './togglePublicSafetyWindowState';

type Props = {
  model: TogglePublicSafetyWindowState;
  visible?: boolean;
};

export const TogglePublicSafetyWindow = observer(({ model, visible }: Props) => {
  return (
    <Window
      model={model.window}
      visible={visible}
      isLoading={model.isLoading}
      className="make-team-public-window">
      <WindowHeader model={model.window} title="Change Public Safety Video Speciality" />

      <hr />

      <div className="window-content">
        <p className="p-bold">
         Are you sure you want to add/remove Public Safety video speciality for this library?
        </p>
      </div>

      <hr />

      <footer className="window-footer">
        <div className="btn-group right">
          <Button
            className="primary btn-outline medium"
            label="Cancel"
            onClick={() => model.close()}
          />
          <Button
            className="red medium"
            label="Confirm"
            onClick={() => model.submit()}
          />
        </div>
      </footer>
    </Window>
  );
});
